import { Component, OnInit } from '@angular/core';
import { LangService } from '../../core/lang.service';

@Component({
  selector: 'link-back-to-dash',
  templateUrl: './link-back-to-dash.component.html',
  styleUrls: ['./link-back-to-dash.component.scss']
})
export class LinkBackToDashComponent implements OnInit {

  constructor(
    private langService:LangService
  ) { }

  ngOnInit() {
  }

  lang(){
    return this.langService.getCurrentLanguage();
  }

}
